// extracted by mini-css-extract-plugin
export default {"root":"i1Elrk","icon":"XIQQ77","text":"cxCW0Q"};